/* eslint-disable no-unused-expressions */
import React, { useEffect } from "react";
import { useRouter } from "next/router";
import {
  AnalyticsProvider as OriginalAnalyticsProvider,
  AnalyticsConsumer,
  withAnalytics,
  federatedPlugin,
  trackEvent as trackEventModule,
  emptyAnalyticsInstance,
} from "@lululemon/mwa-analytics";
import {
  EVENT_PAGE_VIEW,
  PEPS_PROFILE_STORAGE_NAME,
} from "@lululemon/mwa-personalization";

const pepsAnalyticsPlugin = federatedPlugin(
  "peps-analytics-plugin",
  "analyticsFederatedModuleHost",
  "./PepsAnalyticsPlugin",
  {
    // eslint-disable-next-line
    onError: (...args) => console.warn('PEPS ANALYTICS PLUGIN ERROR:', ...args),
  }
);

// const pepsWeatherPlugin = federatedPlugin(
//   'peps-weather-plugin',
//   'analyticsFederatedModuleHost',
//   './WeatherPlugin',
//   {
//     // eslint-disable-next-line no-console
//     onError: (...args) => console.warn('PEPS WEATHER PLUGIN ERROR:', ...args),
//   },
// );

let analyticsInst;

function getInstance() {
  if (typeof window !== "undefined" && window.analytics && !analyticsInst) {
    analyticsInst = window.analytics.analytics;
  }

  return analyticsInst || emptyAnalyticsInstance();
}

// This may look wasteful however, in order to prevent a backtrace exploit we cannot optionally check for the country code
const URL_FILTER =
  /\/[pc]\/.*$|\/search$|\/$|\/\w{2}\-\w{2}\/story\/.*$|\/story\/.*$|\/\w{2}\-\w{2}$|(\/\w{2}-\w{2})?\/outfit-hub(\/)?.*$/;

// eslint-disable-next-line react/prop-types
const AnalyticsProvider = ({ children }) => {
  const router = useRouter();
  useEffect(() => {
    if (router?.events) {
      const handleRouteChange = () => {
        if (
          typeof window !== "undefined" &&
          !URL_FILTER.test(window.location.pathname)
        ) {
          trackEventModule(EVENT_PAGE_VIEW);
        }
      };
      router.events.on("routeChangeComplete", handleRouteChange);
      return () => {
        router.events.off("routeChangeComplete", handleRouteChange);
      };
    }
    return () => {}; // NOSONAR
  }, [router]);
  return (
    <OriginalAnalyticsProvider instance={getInstance()}>
      {children}
    </OriginalAnalyticsProvider>
  );
};

const metarouterPlugin = federatedPlugin(
  "metaRouter-plugin",
  "metarouterPlugin",
  "./MetaRouter",
  {
    // eslint-disable-next-line
    onError: (...args) => console.warn('Metarouter ANALYTICS PLUGIN ERROR:', ...args),
  }
);

// To mwa-common
if (typeof window !== "undefined") {
  window.analyticsPlugins = [
    pepsAnalyticsPlugin({
      profileId: PEPS_PROFILE_STORAGE_NAME,
      enabled: true,
      immediate: true,
    }),
    metarouterPlugin({
      enabled: true,
      immediate: true,
    }),
  ];
}

export {
  AnalyticsProvider,
  AnalyticsConsumer,
  withAnalytics,
  trackEventModule,
};
